import { urls } from "../api/api.urls";
import { makeParams, makeRequestBaseUrl } from "../api/make.request";

export default class AdminServiceV2 {
  static async getCenters(examId: string) {
    return await makeRequestBaseUrl(urls.adminV2.getCenters + "/" + examId, "get");
  }

  static async getCenterInvList(examId: string) {
    return await makeRequestBaseUrl(urls.adminV2.getCenterInvList + "/" + examId, "get");
  }

  static async creaetCenterInv(examId: string) {
    return await makeRequestBaseUrl(urls.adminV2.createCenterInvList + "/" + examId, "post");
  }

  static async getExamMapping(examId: any) {
    return await makeRequestBaseUrl(urls.adminV2.getExamMapping + "/" + examId, "GET")
  }

  static async getVendorSessions(examId: any, url: any, token: any) {
    const params = makeParams([
      {
        index: "url",
        value: url
      },
      {
        index: "token",
        value: token
      }
    ])
    return await makeRequestBaseUrl(urls.adminV2.getVendorSessions + "/" + examId + params, "GET")
  }

  static async createMhcetMapping(examId: any, payload: any) {
    return await makeRequestBaseUrl(urls.adminV2.createMhcetMapping + "/" + examId, "POST", payload)
  }

  static async updateMhcetMapping(examId: any, mappingId: any, payload: any) {
    return await makeRequestBaseUrl(urls.adminV2.updateMhcetMapping + "/" + examId + "/" + mappingId, "PUT", payload)
  }
  
  static async getShiftExport(shiftId: any) {
    return await makeRequestBaseUrl(urls.adminV2.getShiftExport + "/" + shiftId, "GET")
  }

  static async startSync(examId: any, shiftId: any) {
    return await makeRequestBaseUrl(urls.adminV2.startSync + "/" + examId + "/" + shiftId, "POST")
  }

  static async searchReverificationUser(examId: string, capApplicationNumber: string) {
    return await makeRequestBaseUrl(
      urls.adminV2.getReverificationUserSearch + "/" + examId + "/" + capApplicationNumber,
      "GET"
    );
  }

  static async remapReverificationUser(counsellingUserId: string, mapToUserId: string) {
    return await makeRequestBaseUrl(urls.adminV2.remapReverificationUser, "POST", {
      counsellingUser_id: counsellingUserId,
      mapToUserId,
    });
  }

  static async deleteReverification(examId: string, studentId: string, reverificationId: string, shiftId: string) {
    return await makeRequestBaseUrl(
      `${urls.adminV2.deleteReverification}/${examId}/${studentId}/${reverificationId}`,
      "DELETE",
      { shift_id: shiftId }
    );
  }

  static async createAdminSupportUser(payload: { email: string; name: string; password: string; exams: string[] }) {
    return await makeRequestBaseUrl(urls.adminV2.createAdminSupportUser, "POST", payload);
  }

  static async getAdminSupportUsers() {
    return await makeRequestBaseUrl(urls.adminV2.getAdminSupportUsers, "GET");
  }

  static async updateAdminSupportUser(id: string, payload: { password?: string; allowed?: boolean; exams?: string[] }) {
    return await makeRequestBaseUrl(urls.adminV2.updateAdminSupportUser + id, "PUT", payload);
  }
}
